import { CognitoUser } from '@cco/model';
import {
  Auth2Actions,
  AuthenticateUser,
  AuthenticateUserFailure,
  AuthenticateUserSuccess,
  CheckAuthenticationStatus,
  CheckAuthenticationStatusFailure,
  CheckAuthenticationStatusSuccess,
  Logout,
} from '@core/auth2/store/auth2.actions';

export enum Auth2States {
  /*
    NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
    CHECKING_AUTH_STATUS = 'CHECKING_AUTH_STATUS',
    CHECK_AUTH_STATUS_TIMEDOUT = 'CHECK_AUTH_STATUS_TIMEDOUT',
    CHECK_AUTH_STATUS_FAILED = 'CHECKING_AUTH_STATUS_FAILED',
    */
  AUTHENTICATING = 'AUTHENTICATING',
  LOADING_USER_DATA = 'LOADING_USER_DATA',
  AUTHENTICATED = 'AUTHENTICATED',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  // LOGGING_OUT = 'LOGGING_OUT',
  LOGGED_OUT = 'LOGGED_OUT',
}

export interface Auth2Errors {
  LOGIN_FAILURE: string;
}

export interface State {
  authenticated: boolean;
  state: Auth2States;
  previousState: Auth2States;
  currentUser: CognitoUser;
  redirectUrl: string;
}

export const initialState: State = {
  authenticated: false,
  state: Auth2States.LOGGED_OUT,
  previousState: null,
  currentUser: null,
  redirectUrl: null,
};

export function reducer(state = initialState, action: typeof Auth2Actions): State {
  switch (action.type) {
    case CheckAuthenticationStatus.type: {
      return {
        ...state,
        redirectUrl: action.redirectUrl ? action.redirectUrl : null,
      };
    }
    case CheckAuthenticationStatusSuccess.type: {
      const currentUser = action.currentUser;
      return {
        ...state,
        authenticated: true,
        state: Auth2States.AUTHENTICATED,
        previousState: state.state,
        currentUser,
        redirectUrl: null,
      };
    }
    case CheckAuthenticationStatusFailure.type: {
      return {
        ...state,
        authenticated: false,
        state: Auth2States.AUTHENTICATION_FAILED,
        previousState: state.state,
      };
    }
    case AuthenticateUser.type: {
      return {
        ...state,
        authenticated: false,
        state: Auth2States.AUTHENTICATING,
        previousState: state.state,
      };
    }
    case AuthenticateUserSuccess.type: {
      return {
        ...state,
        state: Auth2States.AUTHENTICATED,
        previousState: state.state,
      };
    }
    case AuthenticateUserFailure.type: {
      return {
        ...state,
        authenticated: false,
        state: Auth2States.AUTHENTICATION_FAILED,
        previousState: state.state,
        currentUser: null,
      };
    }
    case Logout.type: {
      return {
        ...state,
        authenticated: false,
        state: Auth2States.LOGGED_OUT,
        previousState: state.state,
        currentUser: null,
      };
    }
    default: {
      return state;
    }
  }
}

export const selectAuthenticated = (state: State) => state.authenticated;

export const selectCurrentUser = (state: State) => state.currentUser;

export const selectCurrentUserPrivileges = (state: State) => {
  const privileges: string[] = [];

  if (!state || !state.currentUser) {
    return null;
  }

  state.currentUser.roles.forEach((role) => {
    role.privileges.forEach((privilege) => {
      privileges.push(privilege.name);
    });
  });

  return privileges;
};

export const selectRedirectUrl = (state: State) => state.redirectUrl;
export const selectState = (state: State) => state.state;
export const selectPreviousState = (state: State) => state.previousState;
